import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Clock } from "lucide-react";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { api } from "../lib/api";

export default function Journal() {
  const [articles, setArticles] = useState([]);

  useEffect(() => {
    document.title = "The Style Journal | Senior Stylist";
    api.get("/articles").then((r) => setArticles(r.data)).catch(() => {});
  }, []);

  return (
    <div className="min-h-screen bg-stylist-bg text-stylist-ink">
      <Navbar />
      <section className="pt-28 pb-20" data-testid="journal-page">
        <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16">
          <span className="eyebrow">Hair &amp; beauty edit</span>
          <h1 className="mt-3 font-serif text-4xl sm:text-5xl lg:text-6xl text-stylist-ink">
            The Style Journal
          </h1>
          <p className="mt-4 max-w-2xl text-stylist-ink2">
            Practical hair care, colour and styling advice, written by certified senior stylists.
          </p>

          <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
            {articles.map((a) => (
              <Link
                key={a.slug}
                to={`/journal/${a.slug}`}
                data-testid={`journal-card-${a.slug}`}
                className="group bg-white border border-stylist-border rounded-lg overflow-hidden hover:shadow-2xl hover:-translate-y-1 hover:border-stylist-gold/40 transition-all duration-500"
              >
                <div className="relative h-56 overflow-hidden">
                  <img
                    src={a.image}
                    alt={a.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                  />
                  <span className="absolute top-4 left-4 text-xs font-mono uppercase tracking-widest bg-white/90 text-stylist-ink px-3 py-1.5 rounded-full">
                    {a.category}
                  </span>
                </div>
                <div className="p-6">
                  <h2 className="font-serif text-xl md:text-2xl text-stylist-ink leading-snug group-hover:text-stylist-gold transition-colors">
                    {a.title}
                  </h2>
                  <p className="mt-3 text-sm text-stylist-ink2 leading-relaxed line-clamp-3">
                    {a.excerpt}
                  </p>
                  <div className="mt-5 flex items-center justify-between">
                    <div className="flex items-center gap-2">
                      <img src={a.author_avatar} alt={a.author} className="w-7 h-7 rounded-full object-cover" />
                      <span className="text-xs text-stylist-ink2">{a.author}</span>
                    </div>
                    <span className="flex items-center gap-1.5 text-xs text-stylist-muted font-mono">
                      <Clock className="w-3.5 h-3.5" />
                      {a.read_time}
                    </span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}
